<template>
  <div></div>
</template>
<script>
export default {
  created() {
    const { path } = this.$route.params;
    this.$router.push(path == 'ReRender' || !path ? '/' : path);
  },
};
</script>
